import { Loader2 } from 'lucide-react';
import type * as React from 'react';

import { cn } from '../utils/cn';
import { useUiLabels } from './ui-labels';

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  const labels = useUiLabels();
  return (
    <Loader2
      role="status"
      aria-label={labels.loading}
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
